import React from "react";
import {
  METRIC_ACCURACY,
  METRIC_NO_SHOW,
  METRIC_WORKSTATION,
  METRIC_EFFICIENCY
} from "../../../constants/metrics";

const metricConfig = {
  [METRIC_ACCURACY]: {
    label: "Accuracy",
    description: "Measures how often booked spaces are actually used.",
    color: "#00d4ff"
  },
  [METRIC_NO_SHOW]: {
    label: "No Show",
    description: "Highlights bookings where no one turned up.",
    color: "#ff4d4f"
  },
  [METRIC_WORKSTATION]: {
    label: "Workstation",
    description: "Tracks utilisation of bookable workspaces.",
    color: "#52c41a"
  },
  [METRIC_EFFICIENCY]: {
    label: "Efficiency",
    description: "Represents how effectively space is being used overall.",
    color: "#722ed1"
  }
};

export default function MetricInsightBar({ selectedMetric }) {

  const metric =
    metricConfig[selectedMetric] || metricConfig[METRIC_EFFICIENCY];

  return (
    <div
      style={{
        ...container,
        background: `linear-gradient(145deg, ${metric.color}22, ${metric.color}44)`
      }}
    >

      {/* LEFT: TITLE + DESC */}
      <div style={left}>
        <div style={title}>{metric.label} Metric</div>
        <div style={desc}>{metric.description}</div>
      </div>

      {/* KPIs */}
      <div style={kpiContainer}>
        <KpiMini label="Max" value="56%" sub="23 Apr 2026" />
		<div style={divider}></div>
        <KpiMini label="Min" value="13%" sub="13 Apr 2026" />
		<div style={divider}></div>
      </div>

      {/* RIGHT: SELECTED BLOCK */}
      <div
        style={{
          ...selectedBlock,
          background: `linear-gradient(145deg, ${metric.color}, ${metric.color}cc)`,
          boxShadow: `0 4px 14px ${metric.color}55`
        }}
      >
        {metric.label.toUpperCase()} SELECTED
      </div>

    </div>
  );
}

/* ================= MINI KPI ================= */

function KpiMini({ label, value, sub }) {
  return (
    <div style={miniKpi}>
      <div style={miniLabel}>{label}</div>
      <div style={miniValue}>{value}</div>
      <div style={miniSub}>{sub}</div>
    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  display: "flex",
  width: "100%",
  borderRadius: "10px",
  padding: "0px 0px", // 🔥 tighter height
  alignItems: "center",
  gap: "20px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  height:'60px'
};

const left = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  paddingLeft:'20px'
};

const title = {
  fontSize: "13px",
  fontWeight: "600",
  color: "#222"
};

const desc = {
  fontSize: "11px",
  color: "#444",
  marginTop: "2px"
};

const selectedBlock = {
  padding: "8px 14px",
  borderRadius: "10px",
  color: "#fff",
  fontSize: "11px",
  fontWeight: "600",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
  height:'calc(100% - 16px)',
  width:'210px',
  display:'flex',
  alignItems:'center',
  justifyContent:'space-around'
};

const kpiContainer = {
  display: "flex",
  alignItems: "center",
  gap: "16px"
};

const miniKpi = {
  display: "flex",
  flexDirection: "column",   // 🔥 stack properly
  justifyContent: "center",  // 🔥 vertical alignment
  alignItems: "flex-end",    // 🔥 right align text
  textAlign: "right",
  minWidth: "90px"           // 🔥 keeps both same width (important!)
};

const miniLabel = {
  fontSize: "11px",
  color: "#555"
};

const miniValue = {
  fontSize: "20px",
  fontWeight: "700",
  color: "#111",
  lineHeight: "20px"
};

const miniSub = {
  fontSize: "11px",
  color: "#666"
};

const divider = {
  width: "1px",
  height: "42px",
  background: "rgba(0,0,0,0.2)" // 🔥 your 0.2 opacity line
};